module.exports = __webpack_public_path__ + "fonts/iconfont.9dd75d2.woff2";